import { message } from 'ant-design-vue';

export default {
  namespaced: true,
  state: {
    /**
     * 获取套餐信息
     */
    setmealData: {},
  },
  actions: {
    /**
     * 获取套餐信息
     */
    async querySetmeal({ commit }, data) {
      const resData = await this.$http.get('/hzwmj/setmeal/list', {
        params: {
          page: data.page,
          size: data.size,
        },
      });
      console.log(resData);
      if (resData.code === 200) {
        const setmealData = resData.data;
        commit('save', { setmealData });
      } else if (resData.code === 900) {
        message.error(resData.msg);
      } else {
        message.error('系统异常');
      }
    },
  },
  mutations: {
    /**
     * 保存状态
     * @param state
     * @param payload
     */
    save(state, payload) {
      for (let key of Object.keys(payload)) {
        state[key] = payload[key];
      }
    },
  },
};
